<template>
  <div class="p-carousel" :class="[className, { bg: showBg }]">
    <div class="p-carousel-box" :class="{ left: textLeft }">
      <div class="p-carousel-box-imgs">
        <VueSlickCarousel :options="settings" ref="carousel">
          <div
            class="img"
            v-for="(item, i) in baseData"
            :key="i"
            @click="tabClick(i)"
          >
            <img :src="item.bigImg" alt=""/>
          </div>
        </VueSlickCarousel>
      </div>
      <div class="p-carousel-box-tabs">
        <div
          class="tab"
          :class="{ active: activeItem.index === i }"
          v-for="(item, i) in baseData"
          :key="i"
          @click="tabClick(i)"
        >
          <div class="title">
            <label class="main">{{ item.title }}</label>
            <label class="sub" v-if="item.sub">{{ item.sub }}</label>
          </div>
          <div class="desc">{{ item.desc }}</div>
          <div class="hr"></div>
          <div :style="hrStyle(i)" class="hr-active"></div>
        </div>
      </div>
    </div>
    <div class="p-carousel-list">
      <div v-for="(item, i) in baseData" :key="i">
        <p class="title">{{ item.title }}</p>
        <p class="desc">{{ item.desc }}</p>
        <img class="icon" :src="item.bigImg" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';
export default {
  name: 'work-component',
  components: { VueSlickCarousel },
  data() {
    return {
      animations: {
        time: 8,
        timer: null,
      },
      activeItem: {
        index: -1,
        time: 0,
      },
      settings: {
        arrows: false,
        dots: false,
        vertical: true,
        draggable: false,
      },
    };
  },
  props: {
    baseData: {
      default: () => {},
    },
    className: {
      default: () => '',
    },
    textLeft: {
      default: () => false,
    },
    showBg: {
      default: () => true,
    },
  },
  watch: {
    baseData: {
      handler: function () {
        this.activeItem = {
          index: -1,
          time: 0,
        };
        setTimeout(() => {
          this.tabClick(0);
        }, 500);
      },
      immediate: true,
    },
  },
  computed: {
    hrStyle() {
      return function (i) {
        return {
          height: (this.activeItem.index === i ? 100 : 0) + '%',
          transition:
            this.activeItem.index === i
              ? `all ${this.animations.time + 2}s`
              : '',
        };
      };
    },
  },
  methods: {
    tabClick(i) {
      if (this.activeItem.index === i) return;
      this.$refs.carousel && this.$refs.carousel.goTo(i);
      this.activeItem = {
        ...this.activeItem,
        index: i,
        time: 0,
      };
      this.init();
    },
    tabNext() {
      let index = this.activeItem.index;
      index++;
      if (index >= this.baseData.length) {
        index = 0;
      }
      this.tabClick(index);
    },
    init() {
      if (this.animations.timer) clearInterval(this.animations.timer);
      this.animations.timer = setInterval(() => {
        this.activeItem = {
          ...this.activeItem,
          time: ++this.activeItem.time,
        };
        if (this.animations.time < this.activeItem.time) {
          clearInterval(this.animations.timer);
          this.animations.timer = null;
          this.tabNext();
        }
      }, 1000);
    },
  },
};
</script>

<style lang="scss" scoped>
.kdv-loading {
  margin-top: 20px;
}
.p-carousel {
  display: flex;
  width: 1200px;
  min-height: 450px;
  margin: 40px auto 0px auto;
  overflow: hidden;
  position: relative;
  
  &.hide {
    height: 0 !important;
    min-height: 0 !important;
  }
  &.edu {
    @include responsiveV2($width-m) {
      min-height: 450px;
    }
  }
  &.solve {
    @include responsiveV2($width-m) {
      min-height: 308px;
    }
  }
  &.ability {
    @include responsiveV2($width-m) {
      min-height: 450px;
    }
  }
  &.ai {
    @include responsiveV2($width-m) {
      min-height: 515px;
    }
  }
  @include responsiveV2($width-m) {
    width: $width-s - 64;
    margin-bottom: 0;
  }
  &-box {
    width: 100%;
    position: relative;
    display: flex;
    align-items: center;
    :deep(.slick-slide) {
      border: none !important;
    }
    &-imgs {
      width: 720px;
      height: 500px;
      @include responsiveV2($width-m) {
        width: 432px;
        height: 300px;
      }
      .img {
        width: 100%;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    &-tabs {
      width: 442px;
      position: absolute;
      right: 0;
      top: 50%;
      transform: translate(0, -50%);

      @include responsiveV2($width-m) {
        width: 320px;
        // height: 326px;
      }
      .tab {
        width: 100%;
        padding-left: 20px;
        position: relative;
        cursor: pointer;
        &.active {
          label {
            color: var(---kd-color-public-normal, #1f69e0) !important;
          }
          .sub {
            border-color: var(---kd-color-public-normal, #1f69e0) !important;
          }
        }
        & + .tab {
          margin-top: 40px;
        }
        .title {
          label {
            color: var(--kd-color-text-primary, rgba(13, 13, 13, 0.9));
            vertical-align: middle;
            cursor: pointer;
          }
          .main {
            font-weight: 600;
            font-size: 20px;
            line-height: 32px;
          }
          .sub {
            border: 1px solid rgba(139, 134, 134, 0.37);
            height: 20px;
            line-height: 20px;
            border-radius: 2px;
            border-width: 1px;
            padding: 0 6px;
            font-size: 12px;
            border-color: rgba(0, 0, 0, 1);
            display: inline-block;
            margin-left: 12px;
          }
        }
        .desc {
          font-size: 14px;
          line-height: 22px;
          margin-top: 6px;
        }
        .hr {
          position: absolute;
          width: 4px;
          height: 100%;
          left: 0px;
          top: 0px;
          background: rgba(13, 13, 13, 0.1);
          border-radius: 4px;
        }
        .hr-active {
          position: absolute;
          width: 4px;
          height: 0%;
          left: 0px;
          top: 0px;
          background: var(---kd-color-public-normal, #1f69e0);
          border-radius: 4px;
        }
      }
    }

    &.left {
      .p-carousel-box-imgs {
        position: absolute;
        right: 0;
        top: 50%;
        transform: translate(0, -50%);
      }
      .p-carousel-box-tabs {
        position: absolute;
        left: 0;
        top: 50%;
        transform: translate(0, -50%);
      }
    }
  }
  &-list {
    width: 100%;
    padding: 0 32px;
    margin-top: 50px;
    display: none;
    .title {
      font-weight: 600;
      font-size: 20px;
      line-height: 32px;
      color: rgba(13, 13, 13, 0.9);
    }
    .desc {
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 22px;
      color: rgba(13, 13, 13, 0.66);
      margin-top: 6px;
    }
    .icon {
      width: 100%;
    }
  }
}
</style>
